import { usePopup } from "@contexts/popupContext";
import styles from '@styles/components/QontactPoints/QontactPointDeletePopup.module.css';
import { useCallback } from "react";

const QontactPointDeletePopup = ({ qontactPoint, deleteQontactPoint }) => {
    const { hidePopup } = usePopup()

    const handleDelete = useCallback(async () => {
        await deleteQontactPoint(qontactPoint);
        // hidePopup();
    }, [qontactPoint, hidePopup]);


    return (
        <div className={styles['popup-container']}>

            <h1>Eliminar {qontactPoint.name}</h1>
            <p>¿Estás seguro que querés eliminar este Qontact Point?</p>
            <div className={styles['modal-actions']}>
                <div className={`${styles['button']} ${styles['cancelar']}`} onClick={hidePopup}>Cancelar</div>
                <div className={`${styles['button']} ${styles['agregar']}`} onClick={handleDelete}>Eliminar</div>
            </div>
        </div>
    )
}

export default QontactPointDeletePopup;